var AppLoadTiming = /** @class */ (function () {
    function AppLoadTiming() {
        this.startTime = null;
        this.endTime = null;
        this.diff = null;
    }
    return AppLoadTiming;
}());
export { AppLoadTiming };
//# sourceMappingURL=app-load-timing.js.map